
import Avatar from "@/components/avatar/index.vue";
import { formatDate } from "@/utils";
import { ICommentItem } from 'blog'
import Vue from 'vue';
import { PropType } from 'vue/types/v3-component-props';

export default Vue.extend({
	components: {
		Avatar,
	},
	props: {
		list: {
			type: Array as PropType<ICommentItem[]>,
			default: () => [] as ICommentItem[],
		},
	},

	methods: {
		formatDate,

	},
	// watch: {
	// 	list: {
	// 		handler(n) {
	// 			console.log(n);

	// 		},
	// 		immediate: true
	// 	}
	// }
})
